/**
 * Returns an object the result templates that matches the given types.
 * @param {Element} component
 * @param {string[]} types
 * @returns {Object}
 */
const getCachedResultTemplatesByTypes = (component, types) => (
    types.reduce((acc, type) => ({
        ...acc,
        [type]: $(component).find(`[data-${type}-results]`).clone(),
    }), {})
);

export default getCachedResultTemplatesByTypes;



// WEBPACK FOOTER //
// ./src/scripts/components/search/getCachedResultTemplatesByTypes.js